import kraftigoProductLogo from "../assets/images/kraftigo/kraftigo-wordmark.png";
import cledgeProductLogo from "../assets/images/cledge/cledge-wordmark-white.png";
import vettingoProductLogo from "../assets/images/vetingo/vetingo-logo.png";

import { FaSearch, FaSitemap, FaPencilRuler, FaRegFileAlt, FaCode, FaCheckCircle, FaTools } from "react-icons/fa";
// chooseus renders on 38 pages; its icons are Lucide to match the rest of the
// redesigned site, which uses react-icons/lu throughout.
import { LuLayers, LuRoute, LuPalette, LuCode, LuUsers, LuHandshake } from "react-icons/lu";
import { Images } from "./Images";

// The 11 non-AI company services — shared by Services.jsx (which still renders
// the full description on its own anchor sections) and the header mega menu /
// dedicated per-service pages (each now has its own route via `path`).
// "Custom Software Development" is intentionally excluded here since it already
// has its own dedicated page under aiServicePages.
export const companyServices = [
  {
    image: Images.web_development_services,
    title: "Web Development Services",
    key: "web_development",
    path: "/web-development",
    description: [
      "We specialize in building dynamic, fast, and secure websites that cater to a diverse set of needs, whether it's a personal blog, a corporate portal, or an e-commerce store. Our team uses modern technologies like React, Next.js, and Vue to build scalable and maintainable websites that offer the best performance. We work closely with clients to ensure that their websites are visually engaging, functional, and responsive across all devices, making sure to integrate SEO best practices and security measures for optimal user experience.",
      "We build fast, responsive, and secure websites using modern frameworks like React, Next.js, and Vue.",
      "Whether it's a landing page or a full-stack app, we've got you covered.",
      "Our web development services ensure that your website is optimized for both performance and user experience.",
      "We create websites that are mobile-first, ensuring a great experience on any device.",
    ],
  },
  {
    image: Images.mobile_app_srvices,
    title: "Mobile App Development Company",
    key: "mobile_app_development",
    path: "/mobile-app-development",
    description: [
      "Our mobile app development services provide businesses with top-tier applications designed for iOS and Android. Using cutting-edge technologies such as React Native and Flutter, we build apps that are optimized for speed, scalability, and user engagement. Whether you're looking for a native mobile app or a cross-platform solution, our development process is streamlined to ensure a smooth user experience. We handle everything from design to deployment, offering ongoing support and maintenance to ensure your app stays ahead in a competitive market.",
      "We craft high-performance native and cross-platform mobile applications for iOS and Android using React Native and Flutter.",
      "We follow a detailed and structured development process to ensure scalability, maintainability, and an engaging user interface.",
      "Our apps are optimized for performance, security, and seamless user experiences.",
      "We focus on delivering apps that are both feature-rich and user-friendly.",
    ],
  },
  {
    image: Images.ui_ux_services,
    title: "UI/UX Design Company",
    key: "ui_ux",
    path: "/ui-ux-design",
    description: [
      "Our UI/UX design services are all about creating seamless, intuitive, and visually compelling experiences. We believe that design is the key to user engagement and retention. Our design process begins with deep research into user needs, which informs every aspect of the design from wireframes to high-fidelity prototypes. We ensure that your product not only looks beautiful but also functions intuitively, creating an interface that your users will enjoy and find easy to navigate, thus ensuring high conversion rates and an exceptional experience.",
      "We create intuitive, beautiful, and user-friendly designs with a focus on accessibility, usability, and experience-driven flows.",
      "Our design process involves wireframing, prototyping, and user testing.",
      "We ensure that your interface is engaging, functional, and reflects your brand identity.",
      "We prioritize user research to understand the needs of your audience and ensure the design meets their expectations.",
    ],
  },
  {
    image: Images.e_commeraces_services,
    title: "E-commerce Website Development",
    key: "ecommerce_development",
    path: "/ecommerce-development",
    description: [
      "We specialize in developing robust e-commerce platforms that are secure, scalable, and optimized for performance. Whether you're starting a new e-commerce store or looking to enhance an existing one, our solutions cater to your specific business needs. We work with popular platforms like Shopify, WooCommerce, and custom-built solutions to deliver user-friendly, fast-loading stores that convert visitors into customers. With seamless payment gateway integration, shopping cart functionality, and advanced inventory management, we ensure your e-commerce business runs smoothly and efficiently.",
      "Scalable, secure, conversion-optimized ecommerce platforms. We build e-commerce stores on Shopify and WooCommerce, or custom-built where the catalog demands it.",
      "We build custom storefronts, integrate seamless payment gateways, and optimize checkout processes.",
      "Analytics, shipping integration, and product management tools ensure your store performs at its best.",
      "We help you grow your e-commerce business with powerful marketing tools and features that improve customer retention.",
    ],
  },
  {
    image: Images.cloud_and_database_services,
    title: "DevOps Services Company",
    key: "cloud_devops_development",
    path: "/devops-services",
    description: [
      "We provide comprehensive cloud and DevOps solutions to help businesses scale their infrastructure, automate processes, and achieve greater agility. Our team specializes in cloud-native architectures using services like AWS, Azure, and Google Cloud, and implements DevOps practices that enhance collaboration between development and operations teams. By automating deployment, configuration management, and monitoring, we reduce downtime, improve security, and increase the efficiency of your operations. With our expertise, you can ensure your cloud infrastructure is robust, flexible, and always ready to meet your growing demands.",
      "Streamline deployment, scalability, and infrastructure with cloud-native architectures using AWS, Azure, Docker, and CI/CD pipelines.",
      "We automate processes and manage cloud infrastructure to increase agility and reduce downtime.",
      "Our DevOps solutions improve collaboration, deployment speed, and reliability.",
      "We offer continuous integration and deployment (CI/CD) to help your team deliver software faster and more reliably.",
    ],
  },
  {
    image: Images.paymentgetway_Services,
    title: "API Development Services",
    key: "payment_getway_development",
    path: "/api-development",
    description: [
      "We offer seamless payment gateway and API integration services to help businesses accept payments securely and manage transactions efficiently. Our team has experience working with leading payment providers like Razorpay, PayPal, and Stripe, as well as custom integrations tailored to your specific needs. We ensure that payment processing is smooth, secure, and fast, providing your customers with a hassle-free checkout experience. In addition, we integrate third-party APIs to extend the functionality of your platform, enabling you to offer enhanced services to your users.",
      "Secure integration of payment gateways (Razorpay, Stripe, PayPal) and third-party APIs to extend your app’s functionality.",
      "We ensure smooth and secure transactions for your customers with multiple payment options.",
      "Our team also handles complex third-party API integrations for enhanced platform capabilities.",
      "We work with leading payment service providers to ensure your transactions are fast and reliable.",
    ],
  },
  {
    image: Images.it_consulting_services,
    title: "Digital Transformation Services",
    key: "it_consulting",
    path: "/digital-transformation",
    description: [
      "We provide expert IT consulting and digital transformation services to help businesses modernize their IT infrastructure and adapt to the changing technology landscape. Our team works closely with clients to assess their current systems and provide actionable strategies to improve efficiency, scalability, and security. Whether it's cloud migration, systems integration, or digital strategy development, we ensure that your IT systems are optimized for both performance and cost-effectiveness, helping you achieve long-term business growth and a competitive advantage.",
      "Empowering businesses through strategic IT consulting and modernization of existing systems for greater efficiency and agility.",
      "We assess your current technology landscape and provide a clear digital transformation roadmap.",
      "Our strategies align technology with business objectives for long-term growth.",
      "We help you navigate the complexities of digital transformation to maximize your return on investment.",
    ],
  },
  {
    image: Images.cyber_security_services,
    title: "Cybersecurity & Compliance",
    key: "cyber_security",
    path: "/cybersecurity-compliance",
    description: [
      "In today's digital landscape, protecting your business from cyber threats is more important than ever. We provide end-to-end cybersecurity solutions to safeguard your systems, data, and customers. Our services include threat detection, data encryption, compliance audits, and ongoing vulnerability assessments. We ensure your systems comply with industry standards and regulations, reducing the risk of data breaches and attacks. With our proactive approach to cybersecurity, you can rest assured that your business is protected against the most sophisticated cyber threats.",
      "Protect your digital assets with end-to-end security services, including threat analysis, data encryption, and compliance audits.",
      "We help you identify vulnerabilities and implement robust security frameworks.",
      "Our services ensure your systems stay compliant with industry regulations and best practices.",
      "We conduct regular security audits and penetration testing to proactively safeguard your data and systems.",
    ],
  },
  {
    image: Images.cloud_and_database_services,
    title: "Cloud Development Services",
    key: "cloud_development",
    path: "/cloud-development",
    description: [
      "We provide comprehensive cloud development services to help businesses build, deploy, and scale applications in cloud environments. Our expertise spans AWS, Azure, Google Cloud, and other leading cloud platforms. We design cloud-first architectures that are secure, scalable, and cost-effective. From serverless computing to containerization with Docker and Kubernetes, we deliver modern cloud solutions that meet your business requirements. Our team ensures optimal performance, security, and compliance while minimizing operational overhead.",
      "Build scalable cloud applications using AWS, Azure, Google Cloud, and containerization technologies.",
      "We design cloud-first architectures optimized for performance, security, and cost-efficiency.",
      "Our cloud development services include serverless computing, microservices, and container orchestration.",
      "We ensure your cloud infrastructure is secure, compliant, and ready for enterprise-scale operations.",
    ],
  },
  {
    image: Images.cloud_and_database_services,
    title: "Cloud Native Applications Development",
    key: "cloud_native_applications",
    path: "/cloud-native-applications",
    description: [
      "We specialize in developing cloud-native applications built from the ground up to leverage cloud computing advantages. These applications are designed using microservices architecture, containerization, and distributed systems principles. Cloud-native apps are highly scalable, resilient, and cost-effective, allowing automatic scaling based on demand. We use technologies like Kubernetes, Docker, and cloud-managed services to build applications that are faster to develop, easier to maintain, and more resilient to failures.",
      "Develop modern cloud-native applications designed for scalability, resilience, and automatic scaling.",
      "We build microservices-based architectures using containerization and orchestration platforms.",
      "Cloud-native apps reduce time-to-market and operational costs while improving reliability.",
      "Our expertise ensures your applications leverage cloud capabilities for maximum performance and efficiency.",
    ],
  },
  {
    image: Images.product_support_services,
    title: "Product Support & Maintenance",
    key: "product_support",
    path: "/product-support-maintenance",
    description: [
      "We offer ongoing product support and maintenance services to ensure that your systems and applications are running smoothly post-launch. Our team provides regular updates, bug fixes, and feature enhancements, ensuring that your products are always up-to-date and meet evolving user needs. We offer 24/7 support and troubleshooting to address any issues your customers face. With our product support services, you can focus on growing your business while we ensure your digital products operate at peak performance.",
      "Comprehensive support services to maintain and enhance your products, with 24/7 assistance.",
      "We ensure timely updates, bug fixes, and improvements to keep your products running smoothly.",
      "Our support services ensure your users get the best experience, free from technical disruptions.",
      "We offer flexible maintenance packages tailored to your product’s lifecycle.",
    ],
  },
];

const findService = (key) => companyServices.find((s) => s.key === key);

// Deterministic anchor id for a facet bullet — lets the mega menu's flyout
// items link to a specific point on the parent service page (e.g.
// /web-development#we-build-fast-responsive) instead of a generic top-of-page
// link, without inventing separate pages/content for each facet.
export const slugifyFacet = (text) =>
  text
    .split(/\s+/)
    .slice(0, 6)
    .join(" ")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

// Dedicated AI service landing pages — shared by Services.jsx, Navbar, and Footer
// so the route list only needs to be maintained in one place.
export const aiServicePages = [
  {
    title: "Agentic AI Development",
    desc: "Build autonomous agent systems with intelligent automation",
    path: "/agentic-ai-development",
    icon: "🤖",
  },
  {
    title: "Recommendation Engine Development",
    desc: "Create AI-powered personalization engines that boost engagement",
    path: "/recommendation-engine-development",
    icon: "📊",
  },
  {
    title: "Generative AI Development",
    desc: "Build generative AI apps and copilots, with evaluation and cost limits",
    path: "/generative-ai-development",
    icon: "✨",
  },
  {
    title: "Custom Software Development",
    desc: "Enterprise-grade bespoke solutions for your unique needs",
    path: "/custom-software-development",
    icon: "💻",
  },
  {
    title: "AI Integration Services",
    desc: "Seamlessly embed AI into your existing systems and workflows",
    path: "/ai-integration-services",
    icon: "🔗",
  },
  {
    title: "LLM Integration Services",
    desc: "Put large language models to work on your own data and systems",
    path: "/llm-integration-services",
    icon: "🧠",
  },
];

// Our own products, as opposed to client work. Shown under the header's
// "Product" menu. Add future products here with title, desc, path and optional logo.
export const productPages = [
  {
    title: "Cledge",
    logo: cledgeProductLogo,
    desc: "Manage your clinic’s daily work with Cledge.",
    path: "/products/cledge",
  },
  { title: "Kraftigo", logo: kraftigoProductLogo, desc: "Connected sales, production planning and inventory for corrugated packaging.", path: "/products/kraftigo" },
  { title: "Vettingo", logo: vettingoProductLogo, desc: "Connected talent workflows with readable records and explainable candidate scoring.", path: "/products/vettingo" },
];

// Header "Services" mega menu — category names and item names mirror the
// Appinventiv reference exactly. Where an item names something we actually
// offer, it links to that real service page and inherits its real facets
// (withFacets). Where an item names something we don't have an existing page
// or track record for (Blockchain, IoT, AR/VR, FinTech Consulting, Big Data,
// Data Analytics, QA and Testing, Product Management), it links to a minimal,
// honestly-worded "tell us about your project" page (EmergingServiceInterest)
// instead of fabricating case studies or expertise claims for work we haven't
// done — see src/pages/EmergingServiceInterest.jsx.
//
// Each facet below is a short, real, named aspect of that service — its title
// is a condensed label for the matching bullet in that service's own
// `description` array, and its own route (ServiceFacetPage) renders that same
// real bullet as body text. No invented capabilities — just that already
// existing content split onto its own URL instead of shown as an anchor.
const SERVICE_FACETS = {
  web_development: [
    { title: "Mobile-First Design", path: "/mobile-first-design", blurb: findService("web_development").description[4] },
    { title: "Performance Optimization", path: "/performance-optimization", blurb: findService("web_development").description[3] },
  ],
  mobile_app_development: [
    { title: "Native & Cross-Platform Apps", path: "/native-cross-platform-apps", blurb: findService("mobile_app_development").description[1] },
    { title: "Performance & Security", path: "/mobile-performance-security", blurb: findService("mobile_app_development").description[3] },
  ],
  ui_ux: [
    { title: "Wireframing & Prototyping", path: "/wireframing-prototyping", blurb: findService("ui_ux").description[2] },
    { title: "User Research", path: "/user-research", blurb: findService("ui_ux").description[4] },
  ],
  cloud_devops_development: [
    { title: "CI/CD Pipelines", path: "/ci-cd-pipelines", blurb: findService("cloud_devops_development").description[4] },
    { title: "Cloud Infrastructure Automation", path: "/cloud-infrastructure-automation", blurb: findService("cloud_devops_development").description[2] },
  ],
  cloud_development: [
    { title: "Serverless & Microservices", path: "/serverless-microservices", blurb: findService("cloud_development").description[3] },
    { title: "Cloud Architecture Design", path: "/cloud-architecture-design", blurb: findService("cloud_development").description[2] },
  ],
  cyber_security: [
    { title: "Security Audits & Pen Testing", path: "/security-audits-pen-testing", blurb: findService("cyber_security").description[4] },
    { title: "Compliance & Regulations", path: "/compliance-regulations", blurb: findService("cyber_security").description[3] },
  ],
  it_consulting: [
    { title: "Legacy System Modernization", path: "/legacy-system-modernization", blurb: findService("it_consulting").description[1] },
    { title: "Digital Transformation Roadmap", path: "/digital-transformation-roadmap", blurb: findService("it_consulting").description[2] },
  ],
  product_support: [
    { title: "24/7 Support & Maintenance", path: "/support-maintenance", blurb: findService("product_support").description[1] },
    { title: "Updates & Bug Fixes", path: "/updates-bug-fixes", blurb: findService("product_support").description[2] },
  ],
};

// A handful of facets are real named aspects of a service but weren't
// already condensed into SERVICE_FACETS above (e.g. Cloud Consulting, Cloud
// Security) — same rule as SERVICE_FACETS: title is a condensed label,
// blurb is the matching real description bullet, nothing invented.
export const extraServiceFacetPages = [
  { title: "Cloud Consulting", path: "/cloud-consulting", blurb: "Independent advice on cloud strategy, platform choice and migration sequencing — before committing budget to a direction.", parentTitle: findService("cloud_development").title, parentPath: findService("cloud_development").path },
  { title: "Cloud Security", path: "/cloud-security-facet", blurb: findService("cloud_development").description[4], parentTitle: findService("cloud_development").title, parentPath: findService("cloud_development").path },
  { title: "Cybersecurity Consulting Services", path: "/cybersecurity-consulting-services", blurb: findService("cyber_security").description[2], parentTitle: findService("cyber_security").title, parentPath: findService("cyber_security").path },
];

export const serviceFacetPages = Object.entries(SERVICE_FACETS).flatMap(([key, facets]) =>
  facets.map((facet) => ({
    ...facet,
    parentTitle: findService(key).title,
    parentPath: findService(key).path,
  }))
);

const withFacets = (key) => ({ key, facets: SERVICE_FACETS[key] });

// Sub-items named here that don't match anything we actually do yet (no
// existing page, no described track record anywhere else on the site) get a
// minimal, honestly-worded "tell us about your project" page — same pattern
// as Blockchain/IoT earlier — instead of invented case studies or claimed
// expertise. See src/pages/EmergingServiceInterest.jsx.
export const newInterestPages = [
  { title: "iOS Development", path: "/ios-development", blurb: "Building a native iOS app? Tell us about your project and we'll figure out the right approach together." },
  { title: "Android Development", path: "/android-development", blurb: "Building a native Android app? Tell us about your project and we'll figure out the right approach together." },
  { title: "PWA Development", path: "/pwa-development", blurb: "Considering a Progressive Web App? Tell us about your project and we'll figure out the right approach together." },
  { title: "Software Integration Services", path: "/software-integration-services", blurb: "Need to integrate systems, tools, or third-party platforms together? Tell us about your project and we'll figure out the right approach together." },
  { title: "SaaS Development", path: "/saas-development", blurb: "Building a SaaS product from the ground up? Tell us about your project and we'll figure out the right approach together." },
  { title: "White Label Development", path: "/white-label-development", blurb: "Looking for a white-label software solution? Tell us about your project and we'll figure out the right approach together." },
  { title: "Software Development Outsourcing", path: "/software-development-outsourcing", blurb: "Looking to outsource part or all of your software development? Tell us about your project and we'll figure out the right approach together." },
  { title: "Offshore Software Development", path: "/offshore-software-development", blurb: "Considering an offshore development team for your project? Tell us about your project and we'll figure out the right approach together." },
  { title: "CRM Development", path: "/crm-development", blurb: "Need a custom CRM built or extended? Tell us about your project and we'll figure out the right approach together." },
  { title: "ERP Services", path: "/erp-services", blurb: "Planning an ERP implementation or customization? Tell us about your project and we'll figure out the right approach together." },
  { title: "Blockchain App Development", path: "/blockchain-app-development", blurb: "Building an application on a blockchain platform? Tell us about your project and we'll figure out the right approach together." },
  { title: "Blockchain Consulting", path: "/blockchain-consulting", blurb: "Evaluating whether blockchain is the right fit for your business? Tell us about your project and we'll figure out the right approach together." },
  { title: "dApp Development", path: "/dapp-development", blurb: "Building a decentralized application? Tell us about your project and we'll figure out the right approach together." },
  { title: "NFT Marketplace Development", path: "/nft-marketplace-development", blurb: "Building an NFT marketplace? Tell us about your project and we'll figure out the right approach together." },
  { title: "Smart Contract Development", path: "/smart-contract-development", blurb: "Need smart contracts developed or audited? Tell us about your project and we'll figure out the right approach together." },
  { title: "Cloud Managed", path: "/cloud-managed", blurb: "Looking for ongoing management of your cloud environment? Tell us about your project and we'll figure out the right approach together." },
  { title: "Cloud Migration", path: "/cloud-migration", blurb: "Planning a migration to the cloud? Tell us about your project and we'll figure out the right approach together." },
  { title: "SecOps", path: "/secops", blurb: "Building out security operations for your systems? Tell us about your project and we'll figure out the right approach together." },
  { title: "Business Intelligence", path: "/business-intelligence", blurb: "Looking to build out BI dashboards or reporting for your business? Tell us about your project and we'll figure out the right approach together." },
];
const findInterestPage = (title) => newInterestPages.find((p) => p.title === title);
const findExtraFacet = (title) => extraServiceFacetPages.find((p) => p.title === title);

export const serviceCategories = [
  {
    title: "Product Development & Engineering",
    items: [
      {
        title: "Product Design",
        path: findService("ui_ux").path,
        facets: [
          { title: "UI/UX", path: findService("ui_ux").path },
          { title: "Mobile-First Design", path: "/mobile-first-design" },
        ],
      },
      {
        title: "Application Development",
        path: findService("web_development").path,
        facets: [
          { title: "Mobile App Development", path: findService("mobile_app_development").path },
          { title: "iOS Development", path: findInterestPage("iOS Development").path },
          { title: "Android Development", path: findInterestPage("Android Development").path },
          { title: "PWA Development", path: findInterestPage("PWA Development").path },
          { title: "Web Development", path: findService("web_development").path },
        ],
      },
      {
        title: "Software Development",
        path: "/custom-software-development",
        facets: [
          { title: "Software Engineering Services", path: "/custom-software-development" },
          { title: "Software Integration Services", path: findInterestPage("Software Integration Services").path },
          { title: "Enterprise Software Development", path: "/custom-software-development" },
          { title: "SaaS Development", path: findInterestPage("SaaS Development").path },
          { title: "White Label Development", path: findInterestPage("White Label Development").path },
          { title: "Software Development Outsourcing", path: findInterestPage("Software Development Outsourcing").path },
          { title: "Offshore Software Development", path: findInterestPage("Offshore Software Development").path },
          { title: "CRM Development", path: findInterestPage("CRM Development").path },
          { title: "ERP Services", path: findInterestPage("ERP Services").path },
        ],
      },
      { title: "QA and Testing", path: "/qa-and-testing" },
      { title: "DevOps", path: findService("cloud_devops_development").path, ...withFacets("cloud_devops_development") },
      { title: "Product Management", path: "/product-management" },
    ],
  },
  {
    title: "Digital Transformation",
    items: [
      { title: "Legacy Application Modernization", path: "/legacy-system-modernization", ...withFacets("it_consulting") },
      {
        title: "Blockchain",
        path: "/blockchain",
        facets: [
          { title: "Blockchain App Development", path: findInterestPage("Blockchain App Development").path },
          { title: "Blockchain Consulting", path: findInterestPage("Blockchain Consulting").path },
          { title: "dApp Development", path: findInterestPage("dApp Development").path },
          { title: "NFT Marketplace Development", path: findInterestPage("NFT Marketplace Development").path },
          { title: "Smart Contract Development", path: findInterestPage("Smart Contract Development").path },
        ],
      },
      {
        title: "Cloud",
        path: findService("cloud_development").path,
        facets: [
          { title: "Cloud Consulting", path: findExtraFacet("Cloud Consulting").path },
          { title: "Cloud Managed", path: findInterestPage("Cloud Managed").path },
          { title: "Cloud Migration", path: findInterestPage("Cloud Migration").path },
          { title: "Cloud Security", path: findExtraFacet("Cloud Security").path },
        ],
      },
      {
        title: "Cybersecurity",
        path: findService("cyber_security").path,
        facets: [
          { title: "SecOps", path: findInterestPage("SecOps").path },
          { title: "Cybersecurity Consulting Services", path: findExtraFacet("Cybersecurity Consulting Services").path },
        ],
      },
      { title: "IoT", path: "/iot" },
    ],
  },
  {
    title: "Consulting Services",
    items: [
      { title: "IT Consulting", path: "/it-consulting" },
      { title: "Software Consulting", path: "/software-consulting" },
      { title: "FinTech Consulting", path: "/fintech-consulting" },
      { title: "Mobile Consulting", path: "/mobile-consulting" },
    ],
  },
  {
    title: "IT Managed & Outsourcing",
    items: [
      { title: "Managed IT Services", path: "/managed-it-services" },
      { title: "IT Audit Services", path: "/it-audit-services" },
    ],
  },
  {
    title: "Data Services",
    items: [
      { title: "Big Data", path: "/big-data" },
      {
        title: "Data Analytics",
        path: "/data-analytics",
        facets: [
          { title: "Business Intelligence", path: findInterestPage("Business Intelligence").path },
        ],
      },
    ],
  },
];

// How the 5 categories above are distributed into the mega menu's 3 columns —
// columns 1 and 3 each stack two categories vertically and column 2 holds
// just one, matching the reference's exact column shape (its 1st and 3rd
// columns stack "IT Managed & Outsourcing" / "Data Services" below the first
// category, its 2nd column stays single).
export const serviceCategoryColumns = [
  [serviceCategories[0], serviceCategories[3]],
  [serviceCategories[1]],
  [serviceCategories[2], serviceCategories[4]],
];

export const tech = [
  {
    name: "Front-End Technologies",
    key: "front-end",
    Descriptions1:
      "Delivering ultra-responsive, immersive, and high-efficiency front-end experiences through cutting-edge frameworks and modern styling tools. We craft visually striking, highly interactive UIs that resonate across devices and browsers.\n\nFrom scalable component-based architectures to lightning-fast rendering, we ensure intuitive navigation and seamless interactivity. Our front-end solutions prioritize both performance and aesthetics, providing users with smooth, polished, and engaging digital experiences.",
    Descriptions2:
      "From scalable component-based architectures to lightning-fast rendering, we ensure intuitive navigation and seamless interactivity. Our front-end solutions prioritize both performance and aesthetics, providing users with smooth, polished, and engaging digital experiences.",
    children: [
      {
        name: "HTML5",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/38/HTML5_Badge.svg",
      },
      {
        name: "CSS3",
        src: "https://upload.wikimedia.org/wikipedia/commons/6/62/CSS3_logo.svg",
      },
      {
        name: "JavaScript",
        src: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
      {
        name: "React",
        src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
      },
      {
        name: "Redux",
        src: "https://upload.wikimedia.org/wikipedia/commons/4/49/Redux.png",
      },
      {
        name: "Angular",
        src: "https://upload.wikimedia.org/wikipedia/commons/6/67/Angular_gradient_logo.png",
      },
      {
        name: "Next.js",
        src: "https://upload.wikimedia.org/wikipedia/commons/8/8e/Nextjs-logo.svg",
      },
      {
        name: "Vue.js",
        src: "https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg",
      },
      {
        name: "TypeScript",
        src: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
      },
      {
        name: "Tailwind CSS",
        src: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
      },
      {
        name: "Bootstrap",
        src: "https://upload.wikimedia.org/wikipedia/commons/b/b2/Bootstrap_logo.svg",
      },
    ],
  },
  {
    name: "Mobile App Development",
    key: "mobile-app",
    Descriptions1:
      "We specialize in crafting high-performance, scalable mobile applications tailored for both iOS and Android platforms. Using technologies like React Native, Flutter, and Swift, we deliver seamless and engaging app experiences.\n\nOur approach ensures optimal user engagement, smooth navigation, and rapid responsiveness. We focus on cross-platform compatibility, efficient codebases, and beautiful design interfaces that keep users coming back.",
    Descriptions2:
      "We build mobile apps with a focus on performance, smooth navigation, and high responsiveness using technologies like React Native, Flutter, and Swift, ensuring rich experiences across iOS and Android platforms.",
    children: [
      {
        name: "Swift",
        src: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Swift_logo.svg",
      },
      {
        name: "Android",
        src: "https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg",
      },
      {
        name: "iOS",
        src: "https://upload.wikimedia.org/wikipedia/commons/c/ca/IOS_logo.svg",
      },
      {
        name: "Flutter",
        src: "https://upload.wikimedia.org/wikipedia/commons/1/17/Google-flutter-logo.png",
      },
      {
        name: "React Native",
        src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
      },
    ],
  },
  {
    name: "Back-End Technologies",
    key: "back-end",
    Descriptions1:
      "Our back-end solutions are robust, secure, and scalable, powering applications with high-performance APIs, secure authentication, and efficient data handling. We use modern frameworks like Node.js, Django, and Laravel to build reliable server-side logic.\n\nWith a focus on scalability and maintainability, we integrate databases, third-party services, and cloud infrastructure seamlessly to support dynamic business needs.",
    Descriptions2:
      "We develop powerful, scalable server-side logic using technologies like Node.js, Django, and Laravel to support efficient APIs, secure authentication, and smooth business operations.",
    children: [
      {
        name: "Node.js",
        src: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
      },
      {
        name: "Django",
        src: "https://upload.wikimedia.org/wikipedia/commons/7/75/Django_logo.svg",
      },
      {
        name: "Flask",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Flask_logo.svg",
      },
      {
        name: "Laravel",
        src: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg",
      },
      {
        name: "GraphQL",
        src: "https://upload.wikimedia.org/wikipedia/commons/1/17/GraphQL_Logo.svg",
      },
      {
        name: "Spring Boot",
        src: "https://upload.wikimedia.org/wikipedia/commons/4/44/Spring_Framework_Logo_2018.svg",
      },
      {
        name: ".NET",
        src: "https://upload.wikimedia.org/wikipedia/commons/e/ee/.NET_Core_Logo.svg",
      },
      {
        name: "Firebase",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/37/Firebase_Logo.svg",
      },
    ],
  },
  {
    name: "Database Management",
    key: "database",
    Descriptions1:
      "We implement scalable and secure database architectures, optimizing data flow, storage, and retrieval using solutions like MongoDB, MySQL, and PostgreSQL. Our database strategies ensure seamless integration and performance across distributed systems.\n\nWith real-time data access, strong indexing, and backup mechanisms, we ensure data integrity and efficient operations across platforms and applications.",
    Descriptions2:
      "Using MongoDB, MySQL, and PostgreSQL, we build secure, scalable databases that ensure high performance, efficient data flow, and seamless integration with front-end and back-end systems.",
    children: [
      {
        name: "MongoDB",
        src: "https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg",
      },
      {
        name: "MySQL",
        src: "https://upload.wikimedia.org/wikipedia/commons/0/0a/MySQL_textlogo.svg",
      },
      {
        name: "PostgreSQL",
        src: "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg",
      },
      {
        name: "Firebase",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/37/Firebase_Logo.svg",
      },
      {
        name: "SQLite",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/38/SQLite370.svg",
      },
    ],
  },
  {
    name: "DevOps",
    key: "devops",
    Descriptions1:
      "We streamline development and deployment processes using DevOps tools like Docker, Kubernetes, Jenkins, and GitHub Actions. Our CI/CD pipelines ensure faster delivery, enhanced collaboration, and minimal downtime.\n\nBy automating workflows and monitoring performance, we optimize resource utilization and increase operational efficiency for both development and production environments.",
    Descriptions2:
      "We implement CI/CD pipelines and cloud-native solutions like Docker and Kubernetes to automate deployments, improve efficiency, and ensure high availability and performance in development environments.",
    children: [
      {
        name: "Docker",
        src: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Docker_%28container_engine%29_logo.svg",
      },
      {
        name: "Kubernetes",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg",
      },
      {
        name: "Jenkins",
        src: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Jenkins_logo.svg",
      },
      {
        name: "GitHub Actions",
        src: "https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg",
      },
      {
        name: "AWS",
        src: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      },
      {
        name: "Azure",
        src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg",
      },
    ],
  },
  {
    name: "Graphics and UI/UX Design",
    key: "design",
    Descriptions1:
      "We craft intuitive, aesthetically pleasing, and user-centric interfaces that enhance digital experiences. Using tools like Figma, Adobe XD, and Photoshop, we design engaging UI/UX strategies that align with user behavior and brand identity.\n\nOur design approach focuses on usability, accessibility, and visual hierarchy to ensure smooth user journeys and lasting impressions.",
    Descriptions2:
      "From wireframes to high-fidelity mockups, we deliver UI/UX designs using tools like Figma and Adobe XD that emphasize usability, brand consistency, and impactful user engagement.",
    children: [
      {
        name: "Figma",
        src: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
      },
      {
        name: "Adobe XD",
        src: "https://upload.wikimedia.org/wikipedia/commons/c/c2/Adobe_XD_CC_icon.svg",
      },
      {
        name: "Photoshop",
        src: "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg",
      },
    ],
  },
];



export const workflowsteps = [
  {
    number: "01",
    title: "Gathering Relevant Information",
    description:
      "We start by understanding your goals, target audience, and business requirements to ensure a solid foundation.",
    icon: FaSearch, // FontAwesome: FaSearch
    color: "#2a9d8f",
  },
  {
    number: "02",
    title: "Planning - Sitemap & Wireframe",
    description:
      "We create a strategic plan including sitemap and wireframes to visualize structure and user flow.",
    icon: FaSitemap, // FontAwesome: FaSitemap
    color: "#264653",
  },
  {
    number: "03",
    title: "Design & Layout",
    description:
      "UI/UX designers craft visually compelling and user-friendly layouts tailored to your brand.",
    icon: FaPencilRuler, // FontAwesome: FaPencilRuler
    color: "#e9c46a",
  },
  {
    number: "04",
    title: "Content Creation",
    description:
      "Our content team curates engaging copy, visuals, and media that align with your message and audience.",
    icon: FaRegFileAlt, // FontAwesome: FaRegFileAlt
    color: "#f4a261",
  },
  {
    number: "05",
    title: "Development",
    description:
      "Our developers bring the designs to life using modern frameworks with clean, scalable code.",
    icon: FaCode, // FontAwesome: FaCode
    color: "#e76f51",
  },
  {
    number: "06",
    title: "Testing, Review & Launch",
    description:
      "We perform thorough testing across devices and browsers, polish details, and prepare for a successful launch.",
    icon: FaCheckCircle, // FontAwesome: FaCheckCircle
    color: "#8ecae6",
  },
  {
    number: "07",
    title: "Maintenance & Updates",
    description:
      "Post-launch, we ensure your platform remains up-to-date, secure, and optimized for growth.",
    icon: FaTools, // FontAwesome: FaTools
    color: "#219ebc",
  },
];


// The six reasons shown under "Why choose us" on 38 pages. The headings and
// icons here were left over from the construction-industry theme this site
// started from — "GENERAL CONTRACTING", "GREEN BUILDING", "HIGH STANDARD
// LABORS", with a building, a house and a bank for icons — while the
// descriptions underneath had already been rewritten for software. Headings
// now say the same thing the description says, in the sentence case the rest
// of the redesigned site uses.
export const chooseus = [
  {
    title: 'Current stack, not trendy stack',
    icon: LuLayers,
    description:
      'We leverage cutting-edge technologies and modern frameworks to build scalable, future-ready software solutions that keep your business ahead of the curve.',
  },
  {
    title: 'One team, kickoff to launch',
    icon: LuRoute,
    description:
      'From project kickoff to final delivery, we manage the entire development lifecycle — ensuring timelines, budgets, and quality standards are always met.',
  },
  {
    title: 'Design and build under one roof',
    icon: LuPalette,
    description:
      'Our UI/UX designers craft intuitive, visually stunning interfaces that not only look great but also deliver a seamless experience across all devices.',
  },
  {
    title: "Code you won't have to rewrite",
    icon: LuCode,
    description:
      'We build clean, optimized, and energy-efficient code — reducing technical debt and ensuring your systems run fast without wasting resources.',
  },
  {
    title: 'Senior engineers, not a rotating bench',
    icon: LuUsers,
    description:
      'Our team consists of experienced developers, engineers, and analysts who bring deep expertise and a passion for quality to every project they touch.',
  },
  {
    title: 'We work inside your team',
    icon: LuHandshake,
    description:
      'We believe great software is built together. Our collaborative culture encourages open communication, creative problem-solving, and shared ownership of success.',
  },
];
export const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/;
// Accepts the formats real people type, in any country: "9876543210",
// "+1 415 555 0123", "(415) 555-0123", "+44 20 7946 0958". The old rule was
// exactly ten digits with no separators, which rejected every international
// number — on a site where most visitors are not in India.
export function isValidPhone(value) {
    const raw = String(value).trim();
    if (!/^\+?[\d\s().-]+$/.test(raw)) return false;
    const digits = raw.replace(/\D/g, "");
    return digits.length >= 7 && digits.length <= 15;
}

 const user = "contact";
  const domain = "inqmisetechnologies.com";
export const emailaddress = `${user}@${domain}`;

// Name, address and phone. Google cross-checks the visible NAP on the page
// against the structured data and against the Business Profile, so this has to
// appear as readable text somewhere on every page — it previously existed only
// inside JSON-LD, where there was nothing to corroborate it.
export const company = {
  name: "InQmise Technologies",
  legalName: "InQmise Technologies India Private Limited",
  street: "Cabin No. 10, Second Floor, A 24/9, Mohan Cooperative",
  locality: "Badarpur",
  region: "New Delhi",
  postalCode: "110044",
  country: "India",
  phone: "+91 81304 09466",
  phoneHref: "+918130409466",
};


// Geo-targeted <title> and meta description for the pages we want ranking on
// local "<service> company in Delhi" queries. Every page previously titled
// itself "<Service> | InQmise Technologies" with no location anywhere on it,
// so nothing on the site matched the city half of those searches.
//
// Keyed by route path. Keep titles under ~60 characters and descriptions under
// ~160, or Google truncates them in the results page. Only pages we genuinely
// want to rank locally belong here — adding the city to all 80+ routes reads
// as doorway spam and can be penalised.
// Related pages each main service page links to, with the target page's
// keyword as the link text (SEO plan, section 6: internal links). Before this,
// several of these pages had one inbound link in page content, and the parent
// pages linked to their facets as "See this facet".
export const relatedServiceLinks = {
  "/cloud-development": [
    { title: "Cloud migration services", path: "/cloud-migration" },
    { title: "Cloud consulting services", path: "/cloud-consulting" },
    { title: "Cloud security services", path: "/cloud-security-facet" },
    { title: "SaaS development", path: "/saas-development" },
  ],
  "/mobile-app-development": [
    { title: "iOS app development", path: "/ios-development" },
    { title: "Android app development", path: "/android-development" },
    { title: "Mobile app consulting", path: "/mobile-consulting" },
  ],
  "/devops-services": [
    { title: "CI/CD pipeline setup", path: "/ci-cd-pipelines" },
    { title: "Software testing and QA services", path: "/qa-and-testing" },
    { title: "Cloud migration services", path: "/cloud-migration" },
  ],
  "/product-support-maintenance": [
    { title: "Software testing and QA services", path: "/qa-and-testing" },
    { title: "Managed IT services", path: "/managed-it-services" },
    { title: "Legacy application modernization", path: "/legacy-system-modernization" },
  ],
  "/digital-transformation": [
    { title: "Business intelligence services", path: "/business-intelligence" },
    { title: "Custom ERP software development", path: "/erp-services" },
    { title: "Software integration services", path: "/software-integration-services" },
    { title: "Cloud migration services", path: "/cloud-migration" },
  ],
  "/api-development": [
    { title: "Software integration services", path: "/software-integration-services" },
    { title: "LLM integration services", path: "/llm-integration-services" },
    { title: "Custom CRM development", path: "/crm-development" },
  ],
  "/cybersecurity-compliance": [
    { title: "VAPT services in India", path: "/security-audits-pen-testing" },
    { title: "Cloud security services", path: "/cloud-security-facet" },
    { title: "Software testing and QA services", path: "/qa-and-testing" },
  ],
  "/web-development": [
    { title: "SaaS development company", path: "/saas-development" },
    { title: "Website performance optimization", path: "/performance-optimization" },
    { title: "Offshore software development", path: "/offshore-software-development" },
  ],
  "/ui-ux-design": [
    { title: "UX research services", path: "/user-research" },
    { title: "Wireframing and prototyping services", path: "/wireframing-prototyping" },
    { title: "Mobile-first web design", path: "/mobile-first-design" },
  ],
  "/ecommerce-development": [
    { title: "Recommendation engine for ecommerce", path: "/recommendation-engine-development" },
    { title: "Custom CRM development", path: "/crm-development" },
    { title: "Business intelligence services", path: "/business-intelligence" },
  ],
  "/cloud-native-applications": [
    { title: "Serverless and microservices development", path: "/serverless-microservices" },
    { title: "Cloud architecture design", path: "/cloud-architecture-design" },
    { title: "SaaS development", path: "/saas-development" },
  ],
  "/custom-software-development": [
    { title: "SaaS development", path: "/saas-development" },
    { title: "Custom CRM development", path: "/crm-development" },
    { title: "Custom ERP software development", path: "/erp-services" },
    { title: "Software integration services", path: "/software-integration-services" },
    { title: "Offshore software development", path: "/offshore-software-development" },
    { title: "Software development outsourcing", path: "/software-development-outsourcing" },
    { title: "Legacy application modernization", path: "/legacy-system-modernization" },
  ],
};

export const localSeo = {
  "/custom-software-development": {
    title: "Custom Software Development Company in Delhi NCR | InQmise",
    description:
      "Custom software development company in Delhi NCR building enterprise-grade bespoke software, SaaS platforms and AI-integrated systems. Talk to our team today.",
  },
  "/web-development": {
    title: "Web Development Company in Delhi NCR | InQmise Technologies",
    description:
      "Web development company in Delhi NCR building fast, secure, responsive websites and web apps in React, Next.js and Vue. Get a quote from our Delhi team.",
  },
  "/mobile-app-development": {
    title: "Mobile App Development Company in Delhi NCR | InQmise",
    description:
      "Mobile app development company in Delhi NCR building native and cross-platform iOS and Android apps with React Native and Flutter. Start your project with us.",
  },
  "/ecommerce-development": {
    title: "E-Commerce Development Company in Delhi NCR | InQmise",
    description:
      "E-commerce development company in Delhi NCR building Shopify, WooCommerce and custom online stores designed to convert visitors into customers.",
  },
  "/ui-ux-design": {
    title: "UI/UX Design Agency in Delhi NCR | InQmise Technologies",
    description:
      "UI/UX design agency in Delhi NCR delivering user research, wireframing, prototyping and mobile-first interface design for web and mobile products.",
  },
  "/digital-transformation": {
    title: "Digital Transformation Services in Delhi NCR | InQmise",
    description:
      "Digital transformation services in Delhi NCR — legacy system modernization, process automation and technology roadmaps for growing businesses.",
  },
  "/cloud-development": {
    title: "Cloud Development Company in Delhi NCR | InQmise",
    description:
      "Cloud development company in Delhi NCR building cloud-native applications, serverless architectures and microservices on AWS and Azure.",
  },
  "/devops-services": {
    title: "DevOps Services in Delhi NCR | InQmise Technologies",
    description:
      "DevOps services in Delhi NCR — CI/CD pipelines, cloud infrastructure automation and container orchestration to ship software faster and more reliably.",
  },
  "/it-consulting": {
    title: "IT Consulting Company in Delhi NCR | InQmise Technologies",
    description:
      "IT consulting company in Delhi NCR providing technology assessments, architecture guidance and clear delivery roadmaps for startups and enterprises.",
  },
  "/ai-solutions": {
    title: "AI Solutions: Agentic AI, LLM & Recommendation Engines",
    description:
      "AI development company in Delhi NCR building agentic AI, generative AI, recommendation engines and AI integrations for real business outcomes.",
  },
};

// Returns the geo-targeted title/description for a route, falling back to the
// page's own copy when that route isn't part of the local SEO set.
export function localSeoFor(routePath, fallbackTitle, fallbackDescription) {
  const entry = localSeo[routePath];
  return {
    title: entry?.title ?? fallbackTitle,
    description: entry?.description ?? fallbackDescription,
  };
}

export const blogPosts = [
  {
    slug: "ezrater",
    category: "INSURTECH",
    title: 'EZRater: The "Kayak for Insurance" That Cracked Cross-Carrier Quote Aggregation',
    description: "A comparative rating platform for surplus lines insurance, EZRater delivers real-time, multi-carrier quoting by solving ACORD interoperability. Built for MGAs, it unifies submissions, integrates 40+ carriers, and provides instant premium indications with a simple, fast user experience.",
    image: Images.cs_ezrater,
  },
  {
    slug: "three-lock-box",
    category: "CONSTRUCTION ESCROW PLATFORM",
    title: "Three Lock Box: Securing Construction Finance Online",
    description: "A transparent, paperless escrow and payment platform for the US construction industry. Built with ASP.NET Core, Razor Pages, and MongoDB, Three Lock Box delivers secure multi-party escrow, real-time dashboards, and end-to-end project transparency for owners, contractors, lenders, and title companies.",
    image: Images.cs_three_lock_box,
  },
  {
    slug: "goal-envision",
    category: "SAAS / STRATEGY",
    title: "GoalEnvision: Turning Strategy Into Visible, Measurable Action",
    description: "A cloud-native SaaS platform for management teams to set, align, and achieve strategic goals. GoalEnvision connects high-level strategy to daily execution with AngularJS dashboards, .NET Core API, and Azure hosting—enabling real-time tracking, team alignment, and actionable insights across five business perspectives.",
    image: Images.cs_goal_envision,
  },
  {
    slug: "gym-chain-integration",
    category: "IOT / FITNESS",
    title: "From Reception Desk to Gym Floor: A Complete Hardware-Software Integration for a Multi-Location Gym Chain",
    description: "A unified hardware-software platform for a multi-location gym chain, integrating CRM, React Native mobile app, QR gate access, and kiosk payments on AWS. Delivers real-time member management, instant access, and seamless in-club transactions—bridging digital and physical operations for a superior gym experience.",
    image: Images.cs_gym_chain_integration,
  },
  {
    slug: "ai-style-recommendation",
    category: "AI / FASHION RETAIL",
    title: "AI-Powered Style Recommendation Engine",
    description: "An AI-driven recommendation engine for a fashion retailer, personalizing product discovery by learning each shopper’s style and behavior. Integrates seamlessly with the existing platform, analyzes browsing and purchase patterns, and delivers 80–90% accuracy in surfacing relevant products—boosting engagement and conversion.",
    image: Images.cs_ai_style_recommendation,
  }
];
